module.exports = __webpack_public_path__ + "img/store-etsy.8ae3cbba.svg";